import React, {
  useState
} from 'react';

import {
  PropTypes
} from 'prop-types';

import {
  useHistory
} from 'react-router-dom';

import styled from 'styled-components';

import {
  HContainerV,
  Text,
  VContainer
} from '@vodacom/web-common';

import {
  PrimaryButton,
  SecondaryButton
} from 'components';

import {
  capitalizeFirstLetter,
  debounce,
  getStorageWithExpiry,
  handleUtagViewEvent
} from 'helpers';

import {
  CustomColors,
  Soid
} from 'constants';

const InfoTitle = styled(Text)`

  color:${CustomColors.Grey11};
  p {
    margin: 10px 0px 0 0px;
    font-weight: 400px;
    font-size: 16px;
  }
`;

export const SocialBundleActivationContainer = ({ isBundleRedeemable=false, onHandleUtagLinkEvent, onActivationStatus, socialBundleType }) => {

  const history = useHistory();

  const [ state, setState ] = useState({ isRedeemButtonNotPressed: true });

  const onBuyDataBundle = () =>{

    onHandleUtagLinkEvent('buy data bundle');

    handleUtagViewEvent({
      page_name:'cbu: connectu: facebook: buy airtime and data advance',
      page_section: 'facebook',
      visitor_customer_segment: getStorageWithExpiry('msisdn', 'msisdnType', ''),
      visitor_type: 'consumer',
      visitor_id_asset_active: getStorageWithExpiry('msisdn', 'hashedMsisdn', '')
    });

    history.push('/pillars/buy');
  };

  const onActivateFreeDataBundle = () => {

    onHandleUtagLinkEvent('activate my free daily data bundle');

    setState({ isRedeemButtonNotPressed: false });

    onActivationStatus(Soid.FaceBookFlex);
  };

  return (

  <HContainerV
    width={'320px'}
    height={'304.5px'}
    margin={'0 12px'}>

    <VContainer>

      <Text
        fontSize={'16px'}
        fontWeight={'400'}
        lineHeight={'18.75px'}
        padding={'5px 250px 10px 0'}
        color={CustomColors.Black5}>
          {'Facebook'}
      </Text>

      <InfoTitle>

        <Text
          fontSize={'20px'}
          fontWeight={'700'}
          padding={'10px 0 10px 0'}
          lineHeight={'23.44px'}>
            {'FREE data bundle every day!'}
        </Text>

        <Text
          fontWeight={'400'}
          lineHeight= {'24px'}
          fontSize={'16px'}>
            {'Keep in contact with your friends and family when you activate this FREE data bundle.'}
        </Text>
      </InfoTitle>

      { state.isRedeemButtonNotPressed &&

        <PrimaryButton
          isEnabled={isBundleRedeemable}
          margin={'13.5px 0 0'}
          height={'40px'}
          textColor={isBundleRedeemable ?  CustomColors.White : CustomColors.TransparentBlack3}
          disabledBackgroundColor={isBundleRedeemable ?  CustomColors.Red1 : CustomColors.White}
          disabledBorderColor={isBundleRedeemable ?  CustomColors.Red1 : CustomColors.TransparentBlack3}
          onClick={debounce(() => onActivateFreeDataBundle())}
          text={ isBundleRedeemable ?  `Activate my FREE ${capitalizeFirstLetter(socialBundleType)} bundle` : `You've redeemed your FREE ${capitalizeFirstLetter(socialBundleType)} bundle`}/>
      }

      <SecondaryButton
        margin={'11.5px 0 0'}
        height={'40px'}
        textColor={isBundleRedeemable ? CustomColors.Grey9 : CustomColors.White }
        activeBackgroundColor={isBundleRedeemable ? CustomColors.White : CustomColors.Red1}
        activeBorderColor={isBundleRedeemable ?  CustomColors.Grey9 : CustomColors.Red1}
        onClick={onBuyDataBundle}
        text={'Buy a data bundle'}/>

    </VContainer>
  </HContainerV>

);
};

SocialBundleActivationContainer.propTypes = {
  isBundleRedeemable: PropTypes.bool,
  onHandleUtagLinkEvent: PropTypes.func,
  onActivationStatus: PropTypes.func,
  socialBundleType: PropTypes.string
};
